import { useState, useCallback, useRef } from 'react'

const useCamera = () => {
  const [stream, setStream] = useState(null)
  const [error, setError] = useState(null)
  const streamRef = useRef(null)

  const startCamera = useCallback(async () => {
    try {
      const constraints = {
        video: {
          facingMode: 'user',
          width: { ideal: 1280 },
          height: { ideal: 720 }
        },
        audio: false
      }

      const mediaStream = await navigator.mediaDevices.getUserMedia(constraints)
      streamRef.current = mediaStream
      setStream(mediaStream)
      setError(null)
      return mediaStream
    } catch (err) {
      console.error('Camera access error:', err)
      setError(err.message)
      throw err
    }
  }, [])

  const stopCamera = useCallback(() => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop())
      streamRef.current = null
      setStream(null)
    }
  }, [])

  return {
    stream,
    error,
    startCamera,
    stopCamera
  }
}

export default useCamera
